'use client';

import { c as _c } from "react/compiler-runtime";
import { Course } from '@udemy-v2/browse-course';
import { LinkGroup } from '@udemy-v2/react-structure-components';
import { useI18n } from '@udemy-v2/i18n';
import classNames from 'classnames';
import styles from './related-topics.module.scss';
import { publishEvent } from '@udemy-v2/event-tracking';
import { BrowseNavigationItemType, BrowseNavigationItemStyle, BrowseNavigationItemSelected } from '../../events/browse-navigation-item-selected';
import { CLPNavigationItem, useCLPNavigationContext } from './hooks/use-clp-navigation-context';
interface RelatedTopicsProps {
  course: Course;
}
export function RelatedTopics(t0) {
  const $ = _c(16);
  const {
    course
  } = t0;
  const {
    gettext
  } = useI18n();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [BrowseNavigationItemType.BADGE];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const topicNavigationContext = useCLPNavigationContext(course, t1);
  if (!topicNavigationContext.length) {
    return null;
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames(styles.title, "ud-heading-xl");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== gettext) {
    t3 = gettext("Explore related topics");
    $[2] = gettext;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <h2 className={t2}>{t3}</h2>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== gettext) {
    t5 = gettext("Explore related topics");
    $[6] = gettext;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== topicNavigationContext) {
    t6 = topicNavigationContext.map(_temp);
    $[8] = topicNavigationContext;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <LinkGroup ariaLabel={t5}>{t6}</LinkGroup>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t7) {
    t8 = <div><div className={styles["topic-navigation"]}>{t4}{t7}</div></div>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
function _temp(navigationItem, index) {
  return <LinkGroup.Item href={navigationItem.url} key={index} onClick={() => {
    publishEvent(new BrowseNavigationItemSelected({
      id: navigationItem.id,
      type: navigationItem.type,
      uiRegion: "browse_navigation",
      style: BrowseNavigationItemStyle.PILL_LIGHT
    }));
  }}>{navigationItem.title}</LinkGroup.Item>;
}